import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'link',
    pure: false
})
export class LikPipe implements PipeTransform {

    constructor() {
}

    transform(text: any) {
        //console.log(text);
        if (text !== null) {
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, (url: any) => {
                const array = url.split('https://www.youtube.com/watch?v=');
                if (array[0] === '') {
                    return `<iframe style="width: 100%; height: 100%;" src="https://www.youtube.com/embed/${array[1]}?controls=1" frameborder="0" allowfullscreen></iframe>`;
                } else {
                    return '<a href="' + url + '" target="_system">link</a>';
                }
            });
        } else {
          return '';
        }
    }
}
